import React, { useCallback } from "react";
import { WSActions, WSElement, WSText } from "@wingspanhq/fe-component-library";
import { useConsentBannerVisibility } from "../hooks/useConsentBannerVisibility";
import { useCookieConsent } from "../hooks/useCookieConsent";
import {
  CONSENT_CATEGORY_ANALYTICS,
  CONSENT_CATEGORY_MARKETING
} from "../types";
import styles from "./CookieConsentBanner.module.scss";
import { WS_LINKS } from "../../../types/wsLinks";

export const CookieConsentBanner: React.FC = () => {
  const { isVisible } = useConsentBannerVisibility();
  const { savePreferences } = useCookieConsent();

  const handleAcceptAll = useCallback(() => {
    savePreferences({
      [CONSENT_CATEGORY_ANALYTICS]: true,
      [CONSENT_CATEGORY_MARKETING]: true
    });
  }, [savePreferences]);

  const handleRejectNonEssential = useCallback(() => {
    savePreferences({
      [CONSENT_CATEGORY_ANALYTICS]: false,
      [CONSENT_CATEGORY_MARKETING]: false
    });
  }, [savePreferences]);

  if (!isVisible) return null;

  return (
    <WSElement className={styles.bannerWrapper}>
      <WSElement
        className={styles.bannerContainer}
        data-testid="cookieConsentBanner"
        role="dialog"
      >
        <WSElement className={styles.bannerContent}>
          <WSElement>
            <WSText.ParagraphSm color="gray700" weight="medium">
              We use cookies.
            </WSText.ParagraphSm>
            <WSText.ParagraphSm color="gray700" mb="M">
              We use analytics and marketing cookies to improve your experience.
              Learn more in our{" "}
              <a
                href={WS_LINKS.wingspanPrivacyPolicyAcceptance}
                target="_blank"
                rel="noopener noreferrer"
              >
                Privacy Policy
              </a>
              .
            </WSText.ParagraphSm>
          </WSElement>

          <WSActions
            sortButtons={false}
            orientation={{
              xs: "vertical",
              s: "horizontal"
            }}
            buttons={[
              {
                label: "Accept essential only",
                kind: "Secondary",
                onClick: handleRejectNonEssential
              },
              {
                label: "Accept all",
                kind: "Primary",
                onClick: handleAcceptAll
              }
            ]}
          />
        </WSElement>
      </WSElement>
    </WSElement>
  );
};
